export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
            <div className="flex-shrink-0 w-48 md:w-56">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20trending%20news%20feed%20with%20warm%20crimson%20and%20amber%20highlights%2C%20dark%20mode%20interface%2C%20Chinese%20social%20media%20app%20design%2C%20clean%20modern%20UI%2C%20entertainment%20gossip%20feed%2C%20minimalist%20layout%2C%20soft%20screen%20glow&width=400&height=800&seq=app-mockup-01&orientation=portrait"
                  alt="吃瓜群移动端界面"
                  className="w-full h-auto rounded-2xl"
                />
              </div>
            </div>

            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
                移动吃瓜
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                随时随地在线吃瓜，吃瓜群移动端体验全面优化。无论是在通勤路上还是茶余饭后，打开手机就能第一时间获取最新爆料、查看实时热度榜、参与瓜友热议。吃瓜从不等待，精彩绝不掉线。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 font-medium text-sm rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill text-base" />
                  App Store
                </button>
                <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 font-medium text-sm rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-google-play-fill text-base" />
                  Google Play
                </button>
              </div>
              <p className="text-xs text-foreground-500 mt-4">
                也可直接收藏网页版，体验同等流畅的移动端浏览
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}